import api from './api';

/**
 * Histórico de agendamentos de uma Person (timeline).
 * Lista ordenada por start_time DESC (mais recente/futuro primeiro); o componente fatia
 * "próximo + 3 últimos" e expande para todos.
 */
const personAppointmentsService = {
  getByPerson: async (personId) => {
    const { data } = await api.get(`/persons/${personId}/appointments`);
    return data;
  },
};

export default personAppointmentsService;
